<template>
    <div v-loading="loading">
        <div class="search-ctn" style="padding: 0 10px; margin-bottom: 10px;">
            <div class="show-info">仓库名称：{{ submitData.Name }}</div>

            <div class="show-info">仓库编号：{{ submitData.Code }}</div>

            <div class="show-info">当前状态：{{ submitData.State | stateHandle }}</div>

            <div class="show-info" v-if="submitData.GoodsLocation">总仓位数量：{{ submitData.GoodsLocation.TotalQuantity }}</div>
            <div class="show-info" v-if="submitData.GoodsLocation">正常使用：{{ submitData.GoodsLocation.NormalQuantity }}</div>
            <div class="show-info" v-if="submitData.GoodsLocation">损坏仓位：{{ submitData.GoodsLocation.AbnormalQuantity }}</div>

            <div class="show-info">存放的商品总数量：{{ submitData.GoodsQuantity }}</div>
        </div>
        <div class="no-data" v-if="noData">该仓库暂无货物</div>
        <div v-else style="border-bottom: 1px solid #ebeef5">
            <div class="section-title">存放商品明细</div>
            <div class="edit-ctn">
                <!--      table title      -->
                <div class="div-table-row table-title">
                    <div class="div-table-cell" style="width: 20%">仓位</div>
                    <div class="div-table-cell" style="width: 20%">汽配编码</div>
                    <div class="div-table-cell" style="width: 20%">互换码</div>
                    <div class="div-table-cell" style="width: 25%">汽配名称</div>
                    <div class="div-table-cell" style="width: 10%">数量</div>
                    <div class="div-table-cell" style="width: 10%">单位</div>
                    <div class="div-table-cell inventory-title" style="width: 15%">
                        <div>库存数据</div>
                        <div>
                            <div>待出库</div>
                            <div>库存</div>
                            <div>留余</div>
                        </div>
                    </div>
                </div>
                <div id="infinite-list" class="table-main" v-infinite-scroll="infiniteLoad" infinite-scroll-distance="10" :infinite-scroll-immediate="false" :infinite-scroll-delay="200">
                    <div :key="index" class="div-table-row table-item" v-for="(item, index) in dataList">
                        <!--        仓位            -->
                        <div class="div-table-cell" style="width: 20%">
                            <el-tooltip effect="dark" :content="item.SSCode" placement="top">
                                <span>{{ item.SSCode }}</span>
                            </el-tooltip>
                        </div>
                        <!--        编码            -->
                        <div class="div-table-cell" style="width: 20%">
                            <el-tooltip effect="dark" :content="item.APCode" placement="top">
                                <span>{{ item.APCode }}</span>
                            </el-tooltip>
                        </div>
                        <!--        互换码            -->
                        <div class="div-table-cell" style="width: 20%">
                            <el-tooltip effect="dark" :content="item.GoodCode" placement="top">
                                <span>{{ item.GoodCode }}</span>
                            </el-tooltip>
                        </div>
                        <!--        汽配名称            -->
                        <div class="div-table-cell" style="width: 25%">
                            <el-tooltip effect="dark" :content="item.GoodName" placement="top">
                                <span>{{ item.GoodName }}</span>
                            </el-tooltip>
                        </div>
                        <!--        数量            -->
                        <div class="div-table-cell" style="width: 10%">
                            <el-tooltip effect="dark" :content="item.Count.toString()" placement="top">
                                <span>{{ item.Count }}</span>
                            </el-tooltip>
                        </div>
                        <!--        单位         -->
                        <div class="div-table-cell" style="width: 10%">{{ item.Unit }}</div>
                        <div class="div-table-cell" style="width: 5%">
                            <el-tooltip effect="dark" :content="item.WaitingOutWarehouseQuantity.toString()" placement="top">
                                <span>{{ item.WaitingOutWarehouseQuantity }}</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 5%">
                            <el-tooltip effect="dark" :content="item.Inventory.toString()" placement="top">
                                <span>{{ item.Inventory }}</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 5%" :class="{ 'color-red': item.Inventory - item.WaitingOutWarehouseQuantity <= 0 }">
                            <el-tooltip effect="dark" :content="(item.Inventory - item.WaitingOutWarehouseQuantity).toString()" placement="top">
                                <span>{{ item.Inventory - item.WaitingOutWarehouseQuantity }}</span>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="div-table-row table-item">
                        <div class="div-table-cell" style="width: 20%"></div>
                        <div class="div-table-cell" style="width: 20%"></div>
                        <div class="div-table-cell" style="width: 20%"></div>
                        <div class="div-table-cell" style="width: 25%"></div>
                        <div class="div-table-cell" style="width: 10%">
                            <el-tooltip effect="dark" :content="allNum.toString()" placement="top">
                                <span>{{ allNum }}</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 10%"></div>
                        <div class="div-table-cell inventory-title" style="width: 15%">
                            <span class="color-red" v-if="lack">库存紧张</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['WarehouseId'],
    components: {},
    data() {
        return {
            loading: false,
            noData: false,
            shopLoad: false,
            lack: true,
            allNum: '',
            allMoney: '',
            dataList: [],
            stopLoad: false,
            searchData: {
                WarehouseId: this.WarehouseId,
                page: 1,
                limit: 20
            },
            submitData: {}
        };
    },
    filters: {
        stateHandle(value) {
            if (value == 0) {
                return '正常使用';
            } else if (value == 1) {
                return '停用';
            }
        }
    },
    mounted() {
        this.getTableData();
    },
    destroyed() {},
    methods: {
        /**
         * 向下滚动加载
         * 在不同浏览器中 v-infinite-scroll 可能会立即执行加载方法
         * 在下面代码中，当this.dataList.length > 0 时才开始进行加载
         */
        infiniteLoad() {
            if (this.shopLoad) {
                // 一页加载完全部数据就不提示了
                if (this.searchData.page > 1) this.$message.info('已经没有更多了哦~');
            } else {
                if (this.dataList.length > 0) {
                    this.searchData.page++;
                    this.getTableData();
                }
            }
        },
        getTableData(typeText) {
            if (this.shopLoad) return;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpWarehouse/GetEntpWarehouseGoodsDetail',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    // 只有Page为1时会返回展示数据
                    if (this.searchData.page === 1) {
                        this.submitData = res.data;
                    }
                    if (res.data.GoodsLocationPartList.length == 0 && this.searchData.page === 1) {
                        this.noData = true;
                        this.loading = false;
                        return;
                    }
                    let DetailList = res.data.GoodsLocationPartList;
                    let _lack = false; // 库存是否紧缺
                    let _allNum = Number(this.allNum);
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        if (DetailList[i].Inventory - DetailList[i].WaitingOutWarehouseQuantity <= 0) {
                            _lack = true;
                        }
                    }
                    this.allNum = _allNum;
                    this.lack = _lack;

                    this.dataList = this.dataList.concat(DetailList);
                    this.shopLoad = DetailList.length < this.searchData.limit || (DetailList.length == this.searchData.limit && DetailList.length == res.data.PartListCount);
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.payment-tip {
    position: absolute;
    left: 0;
    bottom: -18px;
    line-height: 1;
    font-size: 12px;
    color: @font4Color;
}
.form-main {
    display: flex;
    > div {
        width: 33.33%;
    }
}
.inventory-title {
    line-height: 1.2;
    flex-direction: column;
    > div:nth-child(1) {
        width: 100%;
        border-bottom: 1px solid @border3Color;
    }
    > div:nth-child(2) {
        width: 100%;
        display: flex;
        > div {
            width: 33.33%;
        }
    }
}
.form-section {
    display: flex;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    position: relative;
    // .div-table-cell {
    //   padding: 0 5px;
    // }
    &:after {
        position: absolute;
        top: 0;
        left: 0;
        border-left: 1px solid #ebeef5;
        content: '';
        height: 100%;
    }
}
.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 20px;
    margin-bottom: 20px;
}
.option-content {
    display: flex;
    line-height: 30px;
}
.add-btn {
    position: absolute;
    right: -40px;
    bottom: 0;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 0;
    z-index: 2;
}
.business-content-main {
    padding-right: 80px;
}
.table-main {
    position: relative;
    max-height: 55vh;
    overflow: auto;
}
.table-main::-webkit-scrollbar {
    display: none;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex-grow: 1;
}
.table-item {
    height: 40px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
    border-left: none;
}
.show-info{
    flex-shrink: 0;
    margin: 0  10px;
    height: 32px;
    line-height: 32px;
}
</style>
